"use strict";
// Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See LICENSE.txt for license information.
Object.defineProperty(exports, "__esModule", { value: true });
exports.supportsOptions = void 0;
const supportsOptions = (field) => {
    return field.type === 'select' || field.type === 'multiselect';
};
exports.supportsOptions = supportsOptions;
